import { useMemo } from "react";
import { useBalanceSheetQuery } from "@api/accountingReports.api";
import { buildBalanceSheetRows } from "@components/accounting/balanceSheet/balanceSheetViewBuilder";
import {
    CashLedgerReportParams,
    useCashLedgerReportFilters,
} from "../shared/useCashLedgerReportFilters";
import {
    BSSpreadsheetRow,
    mapBSRowToSpreadsheet,
} from "./balanceSheetTaskRows";

export const useBalanceSheetReport = (params: CashLedgerReportParams) => {
    const { ledgerId, ledgersQuery, filters } =
        useCashLedgerReportFilters(params);

    const { balanceSheet } = useBalanceSheetQuery(filters);

    const rows = useMemo((): BSSpreadsheetRow[] | null => {
        if (!balanceSheet.data) {
            return null;
        }
        return buildBalanceSheetRows(balanceSheet.data).map(
            mapBSRowToSpreadsheet,
        );
    }, [balanceSheet.data]);

    return { balanceSheet, rows, ledgerId, ledgersQuery };
};
